 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"9e2febe285c5a40f0e57b520ea9b8b17ca25f169","3":"70ae4567aa691e5fae4db77bd56a8e30816076d9","4":"2bea580225b9fbe16430a905705d455883592bfa","5":"5f81a193574e6e989edd5343b05485403ea97e88","6":"e77e9fba5a4dae5c280d0199de9aec287c338deb","8":"1c74e8d4","11":"component---src-pages-404-tsx","12":"component---src-pages-about-tsx","13":"component---src-pages-acceptable-use-policy-tsx","14":"component---src-pages-add-ons-tsx","15":"component---src-pages-cookie-policy-tsx","16":"component---src-pages-finalized-ingredients-tsx","17":"component---src-pages-index-tsx","18":"component---src-pages-ingredient-reports-tsx","19":"component---src-pages-investors-tsx","20":"component---src-pages-lp-f-1-plant-based-recipes-description-tsx","21":"component---src-pages-lp-f-1-plant-based-recipes-email-tsx","22":"component---src-pages-lp-plant-based-grocery-list-copy-tsx","23":"component---src-pages-lp-plant-based-grocery-list-tsx","24":"component---src-pages-lp-plant-based-meal-kits-tsx","25":"component---src-pages-lp-plant-based-meal-plan-tsx","26":"component---src-pages-lp-plant-based-recipes-tsx","27":"component---src-pages-lp-plant-based-starter-tsx","28":"component---src-pages-plantry-tsx","29":"component---src-pages-privacy-tsx","30":"component---src-pages-reviews-review-tsx","31":"component---src-pages-reviews-thank-you-tsx","32":"component---src-pages-shop-all-recipes-tsx","33":"component---src-pages-shop-now-tsx","34":"component---src-pages-shop-recipes-tsx","35":"component---src-pages-terms-of-service-tsx","36":"component---src-pages-thank-you-tsx","37":"component---src-templates-product-tsx","38":"component---src-templates-recipe-tsx"}[chunkId]||chunkId) + "-" + {"0":"488e2b089322167ca825","1":"e9d24b1846c7d6eb9685","2":"da32eba1625d40cbab83","3":"9b6855696da1bd2c85d7","4":"578dc8066647018eb6cb","5":"ba99218508b3ee4fde6b","6":"02e30660c1fc2b9b86a5","8":"77c41d25e04ff347aef7","11":"1f15c5f492469abb24bc","12":"7662427888967b78dfc3","13":"e5e96d24fb732775bf5d","14":"92b92f2f84e052fd40f8","15":"32f4697e92cce8ce45b4","16":"85fa07da35b3999cbac8","17":"723722b82caee7afbfee","18":"7aa7fce0a75ae4eaeea8","19":"0a994fcc2b77dae5f22e","20":"e98f276e555028fc2fe4","21":"716a78ea8fb5311d2047","22":"b19964458e2fcf86760f","23":"67e567babe02645e2b8f","24":"8eee21d6475c94eb7bbf","25":"af63c144bd1cf2968fe7","26":"a56f3b88ac62e819b4c1","27":"26fe28c4edfc20209404","28":"be6c050edfde077878d1","29":"9caa58766a46ce7c1ae6","30":"fee0a53bdcbc94b8fe94","31":"b60cfe59dff32784f2fb","32":"ab14eee72511b88ac057","33":"4deb8f2649722542cc1f","34":"9411def54526f9a72a85","35":"3102f1580217e19e219e","36":"8f3e10776f4c5c3ebd7d","37":"c6ebefbe65361408a359","38":"0cc063a90ffe31ea2fd0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"9e2febe285c5a40f0e57b520ea9b8b17ca25f169","3":"70ae4567aa691e5fae4db77bd56a8e30816076d9","4":"2bea580225b9fbe16430a905705d455883592bfa","5":"5f81a193574e6e989edd5343b05485403ea97e88","6":"e77e9fba5a4dae5c280d0199de9aec287c338deb","8":"1c74e8d4","11":"component---src-pages-404-tsx","12":"component---src-pages-about-tsx","13":"component---src-pages-acceptable-use-policy-tsx","14":"component---src-pages-add-ons-tsx","15":"component---src-pages-cookie-policy-tsx","16":"component---src-pages-finalized-ingredients-tsx","17":"component---src-pages-index-tsx","18":"component---src-pages-ingredient-reports-tsx","19":"component---src-pages-investors-tsx","20":"component---src-pages-lp-f-1-plant-based-recipes-description-tsx","21":"component---src-pages-lp-f-1-plant-based-recipes-email-tsx","22":"component---src-pages-lp-plant-based-grocery-list-copy-tsx","23":"component---src-pages-lp-plant-based-grocery-list-tsx","24":"component---src-pages-lp-plant-based-meal-kits-tsx","25":"component---src-pages-lp-plant-based-meal-plan-tsx","26":"component---src-pages-lp-plant-based-recipes-tsx","27":"component---src-pages-lp-plant-based-starter-tsx","28":"component---src-pages-plantry-tsx","29":"component---src-pages-privacy-tsx","30":"component---src-pages-reviews-review-tsx","31":"component---src-pages-reviews-thank-you-tsx","32":"component---src-pages-shop-all-recipes-tsx","33":"component---src-pages-shop-now-tsx","34":"component---src-pages-shop-recipes-tsx","35":"component---src-pages-terms-of-service-tsx","36":"component---src-pages-thank-you-tsx","37":"component---src-templates-product-tsx","38":"component---src-templates-recipe-tsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"d416eccc50f5b6e4bc1c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
